import React from 'react';
import styles from './FaqFeedback.module.scss';
import { SFIconButton } from 'sfui';
import { ThumbAction } from '../../../Services/AnalyticsService';

export interface FaqFeedbackProps {
  selected: ThumbAction | undefined;
  onUp: () => void;
  onDown: () => void;
}

export const FaqFeedback = ({
  selected,
  onUp,
  onDown
}: FaqFeedbackProps): React.ReactElement<FaqFeedbackProps> => {
  const onUpClick = () => {
    onUp();
  };

  const onDownClick = () => {
    onDown();
  };

  return (
    <div className={styles.faqFeedback}>
      <h2 className={styles.title}>Was this page helpful?</h2>

      <div className={`${styles.actions} ${!!selected ? styles.disabled : ''}`}>
        <SFIconButton
          className={selected === 'thumb_up' ? styles.selected : ''}
          sfIcon="Thumbs-Up1"
          sfSize="large"
          onClick={onUpClick}
          aria-label="Thumbs up"
        />

        <SFIconButton
          className={selected === 'thumb_down' ? styles.selected : ''}
          sfIcon="Thumbs-Down"
          sfSize="large"
          onClick={onDownClick}
          aria-label="Thumbs down"
        />
      </div>
    </div>
  );
};
